import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { CsrfTokenable } from "./concerns/csrf-tokenable";

// This controller is used to set the color scheme of the page
// theme is stored on the DOM on <html data-bs-theme="XX">
// possible values are: 'dark' and 'light'
export default class extends Controller {

  static values = {
    objectName: String,
    url: String
  }

  static targets = ["button"]

  initialize() {
    Loggable(this, { debug: false })
    CsrfTokenable(this)
  }

  connect() {
    // default object name is "user"
    this.objectNameValue = this.objectNameValue || "user"

    this.log("connected")
  }

  highlightSelection(mode) {
    document.documentElement.dataset.colorSchemeModeValue = mode
    this.dispatch("change", { detail: { mode } })
  }

  syncSelection(event) {
    const mode = event.detail.mode
    this.buttonTargets.forEach(button => {
      const selected = button.dataset.colorSchemeMode === mode
      button.classList.toggle("current-mode", selected)
      button.setAttribute("aria-pressed", String(selected))
    })
  }

  setTheme(newTheme) {
    this.log("setting theme")
    document.querySelector("html").dataset.bsTheme = newTheme
  }

  setDark() {
    this.setTheme("dark")
    this.highlightSelection("dark")
    this.updateUserTheme("dark")
  }

  setLight(){
    this.setTheme("light")
    this.highlightSelection("light")
    this.updateUserTheme("light")
  }

  setAuto(){
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      // dark mode
      this.setTheme("dark")
    } else {
      this.setTheme("light")
    }
    this.highlightSelection("auto")
    this.updateUserTheme("auto")
  }

  updateUserTheme(newMode){
    this.log("updating user theme")
    this.log(this.urlValue)
    let body = {}
    body[this.objectNameValue] = { color_scheme: newMode }
    fetch(this.urlValue, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': this.getCsrfToken()
      },
      body: JSON.stringify(body)
    })
  }

}
